
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"32-a","cx":"50%","cy":"0%","r":"100%","fx":"50%","fy":"0%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#9CF34F"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#52A806"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"51","height":"51","x":"6.5","y":"7.5","fill":"#FFF","stroke":"#FFF","stroke-width":"3","rx":"12"}}),_c('rect',{attrs:{"width":"48","height":"48","x":"8","y":"9","fill":"url(#32-a)","rx":"12"}}),_c('path',{attrs:{"fill":"#FFF","d":"M15.465 33.76l10.12 16.562a.5.5 0 00.847.01L47.5 17.773a.5.5 0 00-.42-.772h-4.807a.5.5 0 00-.422.23l-15.4 24.065a.5.5 0 01-.859-.027l-4.45-8.01a.5.5 0 00-.437-.258h-4.814a.5.5 0 00-.427.76z"}})])])
          )
        }
      }
    